import { NgModule } from "../../../../node_modules/@angular/core";
import { CommonModule } from "../../../../node_modules/@angular/common";
import { HttpClientModule } from "../../../../node_modules/@angular/common/http";
import { CoreModule } from "../../core/core.module";
import { VendorModule } from "../../core/vendor.module";
import { SharedComponentsModule } from "../shared-components.module";
import { SharedServicesModule } from "../../shared-services/shared-services.module";
import { SecurityModule } from "../../security/security.module";
import { NgxMaskModule } from "../../../../node_modules/ngx-mask/build/ngx-mask.module";
import { LoguedGuardService } from "../../security/logued-guard.service";
import { SecurityService } from "../../security/security.service";
import { CotizacionComponent } from "./cotizacion.component";
import { CotizacionListComponent } from "./cotizacion-list/cotizacion-list.component";
import { CotizacionResolver } from "./cotizacion.resolver";
import { CotizacionEditComponent } from "./cotizacion-edit/cotizacion-edit.component";

@NgModule({
    imports: [
      CommonModule,
      HttpClientModule,
      CoreModule,
      VendorModule,
      SharedComponentsModule,
      SharedServicesModule,
      SecurityModule,
      NgxMaskModule,
    ],
    declarations: [
        CotizacionComponent,
        CotizacionListComponent,
        CotizacionEditComponent
    ],
    exports: [
      CotizacionComponent
    ],
    providers: [
      SecurityService,
      LoguedGuardService,
      CotizacionResolver
    ]
  })
  export class CotizacionModule { }


// WEBPACK FOOTER //
// ./src/app/shared-components/cotizacion/cotizacion.module.ts